import type { SVGProps } from 'react'

const SvgUndo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M3.50033 7.00008L1.16699 7.00008L4.08366 9.91675L7.00033 7.00008L4.66699 7.00008C4.66699 6.07182 5.03574 5.18158 5.69212 4.52521C6.3485 3.86883 7.23873 3.50008 8.16699 3.50008C9.09525 3.50008 9.98549 3.86883 10.6419 4.52521C11.2982 5.18158 11.667 6.07182 11.667 7.00008C11.667 7.92834 11.2982 8.81858 10.6419 9.47496C9.98549 10.1313 9.09525 10.5001 8.16699 10.5001V11.6667C9.40467 11.6667 10.5917 11.1751 11.4668 10.2999C12.342 9.42474 12.8337 8.23776 12.8337 7.00008C12.8337 5.7624 12.342 4.57542 11.4668 3.70025C10.5917 2.82508 9.40467 2.33342 8.16699 2.33342C6.92932 2.33342 5.74233 2.82508 4.86716 3.70025C3.99199 4.57542 3.50033 5.7624 3.50033 7.00008Z"
        fill="#5E5E5E"
      />
    </svg>
  )
}

export default SvgUndo
